import React, { useEffect } from "react";
import Header from "../../components/Header";
import Sections from "./Sections";
import strings from "../../utils/locals/languages";
import { Helmet } from "react-helmet-async";
import AdBanners from "./AdBanners";
import RegionAds from "./RegionAds";
import WhatToDo from "./WhatToDo";
import GetTheApp from "./GetTheApp";
import Partners from "./Partners";
import Footer from "../../components/Footer";
import RecommendedVehicles from "../../components/RecommendedVehicles";
import RecommendedRealEstates from "../../components/RecommendedRealEstates";

const SeoMeta = () => (
  <Helmet>
    <html lang={strings._language} />
    <title>{strings.homePageSeoTitle}</title>
    <meta name="description" content={strings.homePageSeoDesc} />
    <meta name="keywords" content={strings.homePageSeoKeyWords} />
    <meta name="author" content="Egasi Team" />
    <link rel="canonical" href="https://egasi.net/" />
  </Helmet>
);

const Home = () => {


  return (
    <>
      <SeoMeta />
      <Header />
      <Sections />
      <div className="space-y-10">
        <AdBanners />
        <hr className="opacity-10" />
        <RecommendedVehicles />
        <hr className="opacity-10" />
        <RecommendedRealEstates />
        <hr />
        <RegionAds />
        <WhatToDo />
        <GetTheApp />
        <Partners />
        <Footer strings={strings} /> 
      </div>
    </>
  );
};

export default Home;
